import { observer } from 'mobx-react'
import React from 'react'
import { IBaseSelect, LFBaseSelect } from './LFBaseSelect'
import { IBaseOption } from './utils'

export type ISelect<
  T extends IBaseOption,
  IsMulti extends boolean = false
> = Omit<
  IBaseSelect<T, IsMulti>,
  'useAsync' | 'cacheUniqs' | 'withNumberSelectUnitDefault'
>

export const LFSelect = observer(
  <T extends IBaseOption, IsMulti extends boolean = false>(
    props: ISelect<T, IsMulti>
  ) => <LFBaseSelect<T, IsMulti> {...props} />
)
